/**
 * Reveal-on-scroll-up header.
 *
 * The bar is sticky, so it never left the screen — which costs vertical room on
 * a long page. It now slides away as you read down and comes straight back the
 * moment you scroll up, which is when someone is looking for the nav or search.
 *
 * Horizon scrolls .page-wrapper rather than the document, so the listener has
 * to attach there; the window is the fallback for any template that does not
 * use the wrapper.
 */
const HIDE_AFTER = 220;  // don't hide until past roughly the header's own height
const DEADZONE = 6;      // ignore jitter and trackpad rubber-banding

class HeaderReveal {
  constructor(el) {
    this.el = el;
    // Which element scrolls varies: Horizon scrolls .page-wrapper on some
    // templates and lets the document scroll on others, and the wrapper exists
    // either way. Rather than guess, listen to both and read whichever moved.
    this.wrapper = document.querySelector('.page-wrapper');
    this.last = this.#top();
    this.hidden = false;

    this.onScroll = () => this.#update();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.wrapper?.addEventListener('scroll', this.onScroll, { passive: true });
  }

  #top() {
    return Math.max(window.scrollY || 0, this.wrapper?.scrollTop || 0);
  }

  #update() {
    const y = this.#top();
    const delta = y - this.last;
    if (Math.abs(delta) < DEADZONE) return;

    // Near the top there is nothing to reclaim, and hiding there reads as a flicker.
    const shouldHide = delta > 0 && y > HIDE_AFTER;
    if (shouldHide !== this.hidden) {
      this.hidden = shouldHide;
      this.el.classList.toggle('is-tucked', shouldHide);
    }
    this.last = y;
  }
}

const el = document.querySelector('.bb-header-sticky');
if (el) new HeaderReveal(el);
